import { z } from 'zod';

import { createApi } from '../core';

export const subscriptionApi = createApi.group(['subscription'], (createKey) => {
  return {
    checkSubscription: createApi.query({
      queryKey: createKey(['checkSubs']),
      queryFn: () => {
        return createApi.fetch({
          path: ['check-subscription'],
          method: 'GET',
          validator: z.object({
            hasValidSubscription: z.boolean(),
          }),
          basePath: 'studentHubAPI',
          sign: true,
        });
      },
    }),
    checkEnrolmentSubscription: createApi.query({
      queryKey: createKey(['checkEnrolmentSubs']),
      queryFn: (params: { enrolmentId: string }) => {
        return createApi.fetch({
          path: ['check-subscription', 'enrolment', params.enrolmentId],
          method: 'GET',
          validator: z.object({
            hasValidSubscription: z.boolean(),
          }),
          basePath: 'studentHubAPI',
          sign: true,
        });
      },
    }),
  };
});
